// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let ReactRelay = require("react-relay");
let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

function makeRefetchVariables(areaIds, fetchAreas, fetchDefaultAreas) {
  return {
    areaIds: areaIds,
    fetchAreas: fetchAreas,
    fetchDefaultAreas: fetchDefaultAreas
  };
}

let Types = {
  makeRefetchVariables: makeRefetchVariables
};

let variablesConverter = {};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

let wrapResponseConverter = {};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, undefined, null);
}

let responseConverter = {};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, undefined, undefined);
}

let Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: undefined,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: undefined,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

let Utils = {};

let node = ((function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "areaIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchAreas"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchDefaultAreas"
},
v3 = [
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "areaIds"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v6 = [
  (v4/*: any*/),
  (v5/*: any*/)
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v8 = [
  (v4/*: any*/),
  (v5/*: any*/),
  (v7/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PropertiesPageRelayWrapperQuery",
    "selections": [
      {
        "condition": "fetchAreas",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "areas",
            "args": (v3/*: any*/),
            "concreteType": "Area",
            "kind": "LinkedField",
            "name": "areasV5",
            "plural": true,
            "selections": (v6/*: any*/),
            "storageKey": null
          }
        ]
      },
      {
        "condition": "fetchDefaultAreas",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ChapterV5",
            "kind": "LinkedField",
            "name": "currentChapterV5",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "concreteType": "ChapterNotificationPreferencesV5",
                  "kind": "LinkedField",
                  "name": "notificationPreferences",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "alias": null,
                        "args": null,
                        "concreteType": "Area",
                        "kind": "LinkedField",
                        "name": "defaultPropertyNotificationAreas",
                        "plural": true,
                        "selections": (v6/*: any*/),
                        "storageKey": null
                      },
                      "action": "NONE"
                    }
                  ],
                  "storageKey": null
                },
                "action": "NONE"
              }
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "PropertiesPageRelayWrapperQuery",
    "selections": [
      {
        "condition": "fetchAreas",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "areas",
            "args": (v3/*: any*/),
            "concreteType": "Area",
            "kind": "LinkedField",
            "name": "areasV5",
            "plural": true,
            "selections": (v8/*: any*/),
            "storageKey": null
          }
        ]
      },
      {
        "condition": "fetchDefaultAreas",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ChapterV5",
            "kind": "LinkedField",
            "name": "currentChapterV5",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ChapterNotificationPreferencesV5",
                "kind": "LinkedField",
                "name": "notificationPreferences",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Area",
                    "kind": "LinkedField",
                    "name": "defaultPropertyNotificationAreas",
                    "plural": true,
                    "selections": (v8/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "5bcd6cf046d6cb47adaa057d638083b5",
    "id": null,
    "metadata": {},
    "name": "PropertiesPageRelayWrapperQuery",
    "operationKind": "query",
    "text": "query PropertiesPageRelayWrapperQuery(\n  $areaIds: [ID!]!\n  $fetchDefaultAreas: Boolean!\n  $fetchAreas: Boolean!\n) {\n  areas: areasV5(ids: $areaIds) @include(if: $fetchAreas) {\n    id\n    label\n    nodeId\n  }\n  currentChapterV5 @include(if: $fetchDefaultAreas) {\n    notificationPreferences {\n      defaultPropertyNotificationAreas {\n        id\n        label\n        nodeId\n      }\n    }\n    nodeId\n  }\n}\n"
  }
};
})());

function load(environment, variables, fetchPolicy, fetchKey, networkCacheConfig) {
  return ReactRelay.loadQuery(environment, node, convertVariables(variables), {
    fetchKey: fetchKey,
    fetchPolicy: fetchPolicy,
    networkCacheConfig: networkCacheConfig
  });
}

function queryRefToObservable(token) {
  return Primitive_option.fromNullable(token.source);
}

function queryRefToPromise(token) {
  return new Promise((resolve, _reject) => {
    let o = queryRefToObservable(token);
    if (o !== undefined) {
      Primitive_option.valFromOption(o).subscribe({
        complete: () => resolve({
          TAG: "Ok",
          _0: undefined
        })
      });
      return;
    } else {
      return resolve({
        TAG: "Error",
        _0: undefined
      });
    }
  });
}

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
exports.load = load;
exports.queryRefToObservable = queryRefToObservable;
exports.queryRefToPromise = queryRefToPromise;
/* node Not a pure module */
